import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import italia from '../../../vendor/italia'

import {actions as areaActions} from '../../../redux/modules/Area'
import {actions as categoriesActions} from '../../../redux/modules/Categories'
import {actions as addressActions} from '../../../redux/modules/Address'
import {actions as registrationActions} from '../../../redux/modules/Registration'
import RegistrationUserInfo from './RegistrationUserInfo'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'

// eslint-disable-next-line
const mailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const ITALIA_COMUNI = italia.comuni.map(item => {
  const label = item.comune + ' (' + item.provincia + ')'
  return {
    label: label,
    value: label
  }
})

const ITALIA_COMUNI_SENZA_LODI_E_ESTERO = ITALIA_COMUNI.slice(2, ITALIA_COMUNI.length)

const mapStateToProps = (state) => {
  return {
    areas: state.area,
    addresses: state.address
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    areaActions: bindActionCreators(areaActions, dispatch),
    categoriesActions: bindActionCreators(categoriesActions, dispatch),
    addressActions: bindActionCreators(addressActions, dispatch),
    registrationActions: bindActionCreators(registrationActions, dispatch)
  }
}

class RegistrationUserInfoContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedArea: null,
      formErrors: {},
      loading: false,
      category: null,
      parkingSpaceSelectedArea: null
    }

    this.onAddressSelected = this.onAddressSelected.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onParkingSpaceAddressSelected = this.onParkingSpaceAddressSelected.bind(this)
  }

  async componentWillMount () {
    this.props.areaActions.fetchAreas()
    this.props.addressActions.fetchAddresses()
    this.setState({loading: true})
    const result = await SostaOnlineApiService.fetchUserCategoryById(this.props.match.params.categoryId)
    console.log(result)
    this.setState({loading: false, category: result.data})
  }

  onAddressSelected (addressId) {
    if (!addressId) {
      this.setState({selectedArea: null})
      return
    }

    let address = this.props.addresses.data.filter(item => {
      return item.id === addressId
    })
    this.setState({selectedArea: address[0].Area})
  }

  getAddressById (addressId) {
    let address = this.props.addresses.data.filter(item => item.id === addressId)
    return address[0]
  }

  onSubmit (values) {
    this.setState({formErrors: {}})

    /* if(!values.captcharesponse) {
            this.setState({formErrors: {form: "Devi dimostrare di non essere un robot"}});
            return;
        } */

    if (!mailRegExp.test(values.email)) {
      this.setState({formErrors: {
        email: 'E-mail non valida'
      }})
      return
    }

    if (values.password.length < 8) {
      this.setState({formErrors: {
        passwords: 'La password deve essere lunga almeno 8 caratteri'
      }})
      return
    }

    if (values.password !== values.repeatedPassword) {
      this.setState({formErrors: {
        passwords: 'Le 2 password non coincidono.'
      }})
      return
    }

    if (this.state.selectedArea) {
      values['areaId'] = this.state.selectedArea.id
    }

    if (this.state.category.resident) {
      values['residenceAreaId'] = this.state.selectedArea.id
      values['residenceAddress'] = this.getAddressById(values.residenceAddress).name
    }

    // values['userCategories'] = [this.state.category];
    // this.props.registrationActions.saveUserInfo(values);
    // this.props.history.push(this.props.nextPath);

    let user = {
      ...values,
      userCategories: [this.state.category.id]
    }

    SostaOnlineApiService.register(user).then(data => {
      this.props.history.push('/register/completed')
    }).catch(err => {
      if (err.error === 'User already exists') {
        this.setState({formErrors: {form: 'Attenzione! Questo utente è già registrato'}})
        return
      }
      if (err.error === "User is not present in Resident's Registry") {
        this.setState({formErrors: {form: 'Attenzione! Il tuo profilo non risulta tra i residenti del Comune di Empoli'}})
        return
      }

      this.setState({formErrors: {form: 'Errore durante la registrazione'}})
    })
  }

  onParkingSpaceAddressSelected (addressId) {
    if (!addressId) {
      this.setState({parkingSpaceSelectedArea: null})
      return
    }

    let address = this.props.addresses.data.filter(item => {
      return item.id === addressId
    })
    this.setState({parkingSpaceSelectedArea: address[0].Area})
  }

  render () {
    const {loading} = this.state

    if (!this.props.addresses.data || !this.props.areas.data || loading) {
      return (<div>Caricamento in corso...</div>)
    }

    return (
      <RegistrationUserInfo
        category={this.state.category}
        comuni={ITALIA_COMUNI}
        comuniWithoutLodi={ITALIA_COMUNI_SENZA_LODI_E_ESTERO}
        addresses={this.props.addresses}
        selectedArea={this.state.selectedArea}
        parkingSpaceSelectedArea={this.state.parkingSpaceSelectedArea}
        onAddressSelected={this.onAddressSelected}
        onParkingSpaceAddressSelected={this.onParkingSpaceAddressSelected}
        areas={this.props.areas.data}
        formErrors={this.state.formErrors}
        onSubmit={this.onSubmit}
      />
    )
  }
}

RegistrationUserInfoContainer.propTypes = {
  category: PropTypes.object.isRequired,
  history: PropTypes.object,
  areas: PropTypes.object,
  areaActions: PropTypes.object,
  addresses: PropTypes.object,
  addressActions: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationUserInfoContainer)



// WEBPACK FOOTER //
// ./src/containers/Registration/UserInfo/RegistrationUserInfoContainer.js